import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { SearchX } from "lucide-react";
import api from "@/api";
import Seo from "@/components/store/Seo";
import ProductCard from "@/components/store/ProductCard";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!q.trim()) { setData({ products: [], total: 0 }); return; }
    setData(null);
    api.get("/products", { params: { q, limit: 48 } }).then(({ data }) => setData(data)).catch(() => setData({ products: [], total: 0 }));
  }, [q]);
  return (
    <div className="tq-container py-10 sm:py-14" data-testid="search-page">
      <Seo title={`Search: ${q}`} noindex />
      <p className="tq-overline mb-2">Search Results</p>
      <h1 className="font-serif text-3xl sm:text-5xl mb-2">"{q}"</h1>
      <p className="text-sm text-[#C59B27] mb-8">{data ? `${data.total} result${data.total === 1 ? "" : "s"}` : "Searching…"}</p>
      {!data ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">{[...Array(4)].map((_, i) => <div key={i} className="aspect-[3/4] bg-[#FAFAFA] animate-pulse" />)}</div>
      ) : data.products.length === 0 ? (
        <div className="text-center py-16" data-testid="search-no-results">
          <SearchX size={40} strokeWidth={1.2} className="mx-auto text-[#A8821B] mb-4" />
          <p className="font-serif text-2xl mb-2">No matches for "{q}"</p>
          <p className="text-sm text-[#666666] mb-6">Try "heels", "juttis" or "sandals".</p>
          <Link to="/collections/new-arrivals" className="tq-btn-dark">Browse New Arrivals</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
          {data.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
